<template>
  <div class="content">
    <div class="columns is-multiline">
      <div class="column is-6">
        <v-card
          :title="$t('ftso-cryptid.title')"
          :subtitle="$t('ftso-cryptid.subtitle')"
          :description="$t('ftso-cryptid.description')"
          imgSrc=""
          github="https://github.com/RLXi/ftso-cryptid"
          hyperlink="https://ftso-cryptid.hynale.fi"
          :card-tags="['react', 'typescript', 'board game', 'helper', 'WIP']"
          :privateRepo="false"
        />
      </div>
      <div class="column is-6">
        <v-card
          :title="$t('discord-tta.title')"
          :subtitle="$t('discord-tta.subtitle')"
          :description="$t('discord-tta.description')"
          imgSrc=""
          github="https://github.com/RLXi/discord-tta-bot"
          :card-tags="[
            'javascript',
            'discord',
            'bot',
            'board game',
            'helper',
            'WIP'
          ]"
          :privateRepo="false"
        />
      </div>
      <div class="column is-6">
        <v-card
          :title="$t('cryptid.title')"
          :subtitle="$t('cryptid.subtitle')"
          :description="$t('cryptid.description')"
          imgSrc=""
          github="https://github.com/RLXi/cryptid-solver"
          :hyperlink="{ name: 'cryptid-app' }"
          :local="true"
          :card-tags="['javascript', 'board game', 'helper']"
          :privateRepo="false"
        />
      </div>
      <!-- <div class="column is-6 ">
        <v-card
          :title="$t('dbscraper.title')"
          :subtitle="$t('dbscraper.subtitle')"
          :description="$t('dbscraper.description')"
          imgSrc=""
          github=""
          :card-tags="['scraper', 'typescript', 'deno']"
        />
      </div> -->
      <div class="column is-6 ">
        <v-card
          :title="$t('dyson.title')"
          :subtitle="$t('dyson.subtitle')"
          :description="$t('dyson.description')"
          imgSrc="dyson.png"
          github="https://github.com/RLXi/dyson-sphere-game"
          :hyperlink="{ name: 'dyson-app' }"
          :local="true"
          :card-tags="['game', 'javascript', 'phaser']"
          :privateRepo="false"
        />
      </div>
      <div class="column is-6 ">
        <v-card
          :title="$t('nations.title')"
          :subtitle="$t('nations.subtitle')"
          :description="$t('nations.description')"
          imgSrc="nations.png"
          github="https://github.com/RLXi/nations-randomizer"
          :hyperlink="{ name: 'nations-app' }"
          :local="true"
          :card-tags="['board game', 'javascript', 'vue', 'helper']"
          :privateRepo="false"
        />
      </div>
      <!-- <div class="column is-6 ">
                <v-card
                    :title="$t('gs.title')"
                    :subtitle="$t('gs.subtitle')"
                    :description="$t('gs.description')"
                    imgSrc=""
                    github=""
                    hyperlink=""
                    :private-repo="false"
                    :card-tags="['javascript']"
                />
            </div> -->
      <div class="column is-6 ">
        <v-card
          :title="$t('kks.title')"
          :subtitle="$t('kks.subtitle')"
          :description="$t('kks.description')"
          imgSrc=""
          github="https://github.com/RLXi/kks-original"
          hyperlink=""
          :card-tags="['php', 'mysql', 'javascript', 'jquery']"
        />
      </div>
      <div class="column is-6 ">
        <v-card
          :title="$t('portfolio.title')"
          :subtitle="$t('portfolio.subtitle')"
          :description="$t('portfolio.description')"
          imgSrc=""
          github="https://github.com/RLXi/portfolio"
          hyperlink=""
          :card-tags="['javascript', 'vue', 'bulma', 'i18n', 'aws', 'spa']"
        />
      </div>
    </div>
    <!-- <div v-if="dataReady">
      <div class="column is-6" v-for="project in projects" :key="project.title">
        <v-card
          :title="project.title"
          :subtitle="project.subtitle"
          :description="project.description"
          :imgSrc="project.imgSrc"
          :github="project.github"
          :hyperlink="project.hyperlink"
          :local="project.local"
          :card-tags="project['card-tags']"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import vCard from "@/vue/components/vCard";
import { i18nMixin } from "@/vue/mixins/i18nMixin";

export default {
  name: "projects",
  mixins: [i18nMixin],
  components: {
    vCard
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped></style>

<i18n>
{
    "en": {
        "pageTitle": "Projects",
        "kks": {
            "title": "DTTS",
            "subtitle": "Web application",
            "description": "Driver Training Tracking System made during conscription."
        },
        "dyson": {
            "title": "Dyson Sphere",
            "subtitle": "Game",
            "description": "Simple game"
        },
        "nations": {
            "title": "Nations Randomizer",
            "subtitle": "Web application",
            "description": "Support app for Nations board game."
        },
        "gs": {
            "title": "General Scorer",
            "subtitle": "Web application",
            "description": "Support app for any board game that requires calculating points at the end."
        },
        "portfolio": {
            "title": "Portfolio",
            "subtitle": "Website",
            "description": "This site. Run on AWS bucket."
        },
        "cryptid": {
            "title": "Cryptid solver",
            "subtitle": "Web app",
            "description": "Helper app for Cryptid board game. It seek possible correct answers based on the current game board."
        },
        "ftso-cryptid": {
            "title": "ftso-cryptid",
            "subtitle": "Web app",
            "description": "Improved version of my Cryptid solver app. Work in progress."
        },
        "dbscraper": {
            "title": "DB Scraper",
            "subtitle": "CLI tool",
            "description": "Booru imageboard scraper tool."
        },
        "discord-tta": {
              "title": "Discord TTA bot",
            "subtitle": "Chatbot",
            "description": "Discord bot that manages TTA players. Work in progress."
        }
    },
    "fi": {
        "pageTitle": "Projektit",
        "kks": {
            "title": "KKS",
            "subtitle": "Web-sovellus",
            "description": "Asepalveluksen aikana kehitetty kuljettajakoulutuksen seurantajärjestelmä."
        },
        "dyson": {
            "title": "Dyson Sphere",
            "subtitle": "Peli",
            "description": "Yksinkertainen Phaserilla toteutettu peli, jossa suojellaan tukikohtaa loputtomalta vihollislaumalta."
        },
        "nations": {
            "title": "Nations Randomizer",
            "subtitle": "Web-sovellus",
            "description": "Nations -lautapelin apuväline, jolla voi arpoa pelaajien valtiot."
        },
        "portfolio": {
            "title": "Portfolio",
            "subtitle": "Websivusto",
            "description": "Tämä sivusto. Pyörii AWS ämpärissä."
        },
        "cryptid": {
            "title": "Cryptid solver",
            "subtitle": "Web-sovellus",
            "description": "Cryptid -lautapelin aputyökalu. Se etsii mahdolliset oikeat vastaukset pelilaudan perusteella."
        },
        "ftso-cryptid": {
            "title": "ftso-cryptid",
            "subtitle": "Web-sovellus",
            "description": "Paranneltu versio Cryptid ratkaisijastani. Vielä keskeneräinen."
        },
        "dbscraper": {
            "title": "DB Scraper",
            "subtitle": "Komentorivityökalu",
            "description": "Booru kuvafoorumin scraper työkalu."
        },
        "discord-tta": {
              "title": "Discord TTA bot",
            "subtitle": "Chatbot",
            "description": "Discord bot, joka koordinoi TTA lautapelin pelaajia. Vielä keskeneräinen."
        }
    }
}
</i18n>
